import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Footer.module.css';
import Youtube from '../../../images/Youtube.png';
import Instagram from '../../../images/instagram.png';
import Facebook from '../../../images/Facebook.png';
import Twitter from '../../../images/Twitter.png';
import Visa from '../../../images/Visa.png';
import MasterCard from '../../../images/Mastercard.png';

const Footer = () => {
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Enables smooth scrolling
    });
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.iconRow}>
        <div className={styles.socialIcons}>
          <NavLink
            to="https://www.instagram.com/datinglifecoachuk/"
            target="_blank"
            rel="noopener noreferrer"
            className={({ isActive }) =>
              isActive ? styles.active : styles.icon
            }
          >
            <img loading="lazy" src={Instagram} alt="Instagram" />
          </NavLink>
          <NavLink
            to="https://www.youtube.com/@IkharatinKharatin"
            target="_blank"
            rel="noopener noreferrer"
            className={({ isActive }) =>
              isActive ? styles.active : styles.icon
            }
          >
            <img loading="lazy" src={Youtube} alt="YouTube" />
          </NavLink>
          <NavLink
            to="https://www.facebook.com/dateandlifecoachuk/"
            target="_blank"
            rel="noopener noreferrer"
            className={({ isActive }) =>
              isActive ? styles.active : styles.icon
            }
          >
            <img loading="lazy" src={Facebook} alt="Facebook" />
          </NavLink>
          <NavLink
            to="https://x.com/DatinCoachUK"
            target="_blank"
            rel="noopener noreferrer"
            className={({ isActive }) =>
              isActive ? styles.active : styles.icon
            }
          >
            <img loading="lazy" src={Twitter} alt="Twitter" />
          </NavLink>
        </div>
        <div className={styles.paymentIcons}>
          <img loading="lazy" src={Visa} alt="Visa" />
          <img loading="lazy" src={MasterCard} alt="MasterCard" />
        </div>
      </div>

      <div className={styles.footerText}>
        <p> Owned By DREAMONELOVE LIMITED</p>

        <p>3rd Floor 207 Regent Street, London, W1B 3HH</p>

        <p>
          <NavLink
            to="/info/terms-and-conditions"
            className={styles.link}
            onClick={handleScrollToTop}
          >
            Terms Of Use
          </NavLink>
          |
          <NavLink
            to="/info/privacy-policy"
            className={styles.link}
            onClick={handleScrollToTop}
          >
            Privacy Policy
          </NavLink>
          |
          <NavLink
            to="/info/refund-policy"
            className={styles.link}
            onClick={handleScrollToTop}
          >
            Refund Policy
          </NavLink>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
